import { ActividadDTO, IActividadDTO } from "./Actividad.DTO";
import { TagDTO } from "./Tag.DTO";
import { ValidacionDTO } from "./Validacion.DTO";
import { GrupoDTO, IGrupoDTO } from "./Grupo.DTO";
import { PaisDTO } from "./Pais.DTO";
import { Nilable } from "@shared/utils";
import { GeneroEnum, obtenerIdGenero } from "@shared/enums";

export interface IPanelistaDTO {
    id: number;
    active: boolean;
    activity: Nilable<IActividadDTO[]>;
    age_range: string;
    app_version: string;
    birth_year: number;
    campaigns: Nilable<IGrupoDTO[]>;
    city: Nilable<string>;
    city_name: Nilable<string>;
    country: string;
    created_at: string;
    device_language: Nilable<string>;
    imei: string;
    earned_until: string;
    extra_until: string;
    email: string;
    engagement: number;
    exchanges_delivered: number;
    exchanges_requested: number;
    gaid: Nilable<string>;
    gender: Nilable<string>;
    latitude: Nilable<number>;
    last_activity: Nilable<string>;
    last_message: Nilable<string>;
    longitude: Nilable<number>;
    region_name: Nilable<string>;
    score: number;
    score_earned: number;
    score_extra: number;
    score_spent: number;
    spent_until: string;
    terms_accepted: boolean;
    operating_system: string;
    verified_phone_number: boolean;
    blacklist: boolean;
    url_avatar?: Nilable<string>;
}

export class PanelistaDTO {
    public id = 0;
    public activo = true;
    public actividad: ActividadDTO[] = [];
    public rangoEdad = "";
    public appVersion = "";
    public yearNacimiento = 0;
    public grupos: GrupoDTO[] = [];
    public ciudad = "";
    public ciudadNombre = "";
    public pais = new PaisDTO();
    public creadoEn = "";
    public lenguajeDispositivo = "";
    public imei = "";
    public ganadoHasta = "";
    public extraHasta = "";
    public email = "";
    public compromiso = 0;
    public canjesEntregados = 0;
    public canjesPedidos = 0;
    public gaid = "";
    public genero = GeneroEnum.MALE;
    public latitud = 0;
    public ultimaActividad = "";
    public ultimoMensaje = "";
    public longitud = 0;
    public nombreRegion = "";
    public puntos = 0;
    public puntosGanados = 0;
    public puntosExtra = 0;
    public puntosGastados = 0;
    public gastadosHasta = "";
    public terminosAceptados = true;
    public sistemaOperativo = "";
    public telefonoVerificado = true;
    public tags: TagDTO[] = [];
    public validaciones = new ValidacionDTO();
    public estaEnBlacklist = false;
    public urlAvatar: Nilable<string> = null;

    constructor(json: Nilable<Partial<IPanelistaDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IPanelistaDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.active != null) {
            this.activo = json.active;
        }
        if (json.activity != null) {
            this.actividad = json.activity.map(actividad => new ActividadDTO(actividad));
        }
        if (json.age_range != null) {
            this.rangoEdad = json.age_range;
        }
        if (json.app_version != null) {
            this.appVersion = json.app_version;
        }
        if (json.birth_year != null) {
            this.yearNacimiento = json.birth_year;
        }
        if (json.campaigns != null) {
            this.grupos = json.campaigns.map(grupo => new GrupoDTO(grupo));
        }
        if (json.city != null) {
            this.ciudad = json.city;
        }
        if (json.city_name != null) {
            this.ciudadNombre = json.city_name;
        }
        if (json.country != null) {
            this.pais = new PaisDTO({ code: json.country });
        }
        if (json.created_at != null) {
            this.creadoEn = json.created_at;
        }
        if (json.device_language != null) {
            this.lenguajeDispositivo = json.device_language;
        }
        if (json.imei != null) {
            this.imei = json.imei;
        }
        if (json.earned_until != null) {
            this.ganadoHasta = json.earned_until;
        }
        if (json.extra_until != null) {
            this.extraHasta = json.extra_until;
        }
        if (json.email != null) {
            this.email = json.email;
        }
        if (json.engagement != null) {
            this.compromiso = json.engagement;
        }
        if (json.exchanges_delivered != null) {
            this.canjesEntregados = json.exchanges_delivered;
        }
        if (json.exchanges_requested != null) {
            this.canjesPedidos = json.exchanges_requested;
        }
        if (json.gaid != null) {
            this.gaid = json.gaid;
        }
        if (json.gender != null) {
            this.genero = GeneroEnum[json.gender];
        }
        if (json.latitude != null) {
            this.latitud = json.latitude;
        }
        if (json.last_activity != null) {
            this.ultimaActividad = json.last_activity;
        }
        if (json.last_message != null) {
            this.ultimoMensaje = json.last_message;
        }
        if (json.longitude != null) {
            this.longitud = json.longitude;
        }
        if (json.region_name != null) {
            this.nombreRegion = json.region_name;
        }
        if (json.score != null) {
            this.puntos = json.score;
        }
        if (json.score_earned != null) {
            this.puntosGanados = json.score_earned;
        }
        if (json.score_extra != null) {
            this.puntosExtra = json.score_extra;
        }
        if (json.score_spent != null) {
            this.puntosGastados = json.score_spent;
        }
        if (json.spent_until != null) {
            this.gastadosHasta = json.spent_until;
        }
        if (json.terms_accepted != null) {
            this.terminosAceptados = json.terms_accepted;
        }
        if (json.operating_system != null) {
            this.sistemaOperativo = json.operating_system;
        }
        if (json.verified_phone_number != null) {
            this.telefonoVerificado = json.verified_phone_number;
        }
        if (json.blacklist != null) {
            this.estaEnBlacklist = json.blacklist;
        }
        if (json.url_avatar != null) {
            this.urlAvatar = json.url_avatar;
        }
    }

    public toJSON(): IPanelistaDTO {
        return {
            id: this.id,
            active: this.activo,
            activity: this.actividad?.map(actividad => actividad.toJSON()),
            age_range: this.rangoEdad,
            app_version: this.appVersion,
            birth_year: this.yearNacimiento,
            campaigns: this.grupos?.map(grupo => grupo.obtenerJSON()),
            city: this.ciudad,
            city_name: this.ciudadNombre,
            country: this.pais.codigo,
            created_at: this.creadoEn,
            device_language: this.lenguajeDispositivo,
            imei: this.imei,
            earned_until: this.ganadoHasta,
            extra_until: this.extraHasta,
            email: this.email,
            engagement: this.compromiso,
            exchanges_delivered: this.canjesEntregados,
            exchanges_requested: this.canjesPedidos,
            gaid: this.gaid,
            gender: obtenerIdGenero(this.genero),
            latitude: this.latitud,
            last_activity: this.ultimaActividad,
            last_message: this.ultimoMensaje,
            longitude: this.longitud,
            region_name: this.nombreRegion,
            score: this.puntos,
            score_earned: this.puntosGanados,
            score_extra: this.puntosExtra,
            score_spent: this.puntosGastados,
            spent_until: this.gastadosHasta,
            terms_accepted: this.terminosAceptados,
            operating_system: this.sistemaOperativo,
            verified_phone_number: this.telefonoVerificado,
            blacklist: this.estaEnBlacklist
        };
    }
}
